import styled from 'styled-components';
import { themes } from 'kb-shared';
import TextareaAutosize from 'react-textarea-autosize';
import { DarkButton } from 'components/Buttons';

export const Main = styled.div`
  background-color: ${({ theme }) => theme.colors.beige};
  padding-bottom: 0.5em;
  height: fit-content;
`;

export const Subject = styled.div`
  ${({ theme }) => theme.fonts.FoundersGrotesk};
  font-weight: bold;
  text-align: center;
  padding: 1em 0;
  border-bottom: 2px solid rgb(199, 183, 167);
`; // TODO: save color variable

export const Messages = styled.div`
  max-height: 500px;
  overflow: auto;
`;

export const Centered = styled.div`
  display: flex;
  justify-content: center;
  margin: 3em;
`;

export const WhiteInput = styled.div`
  background: white;
  color: ${({ theme }) => theme.colors.night};
  padding: 1em;
  border-radius: 15px;
  width: -webkit-fill-available;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
`;

export const Container = styled.div`
  margin: 1.5em;
  @media (min-width: ${({ theme }) => theme.breakpoints.largePhonePortrait}) {
    margin: 2em;
  }
`;

export const SendButton = styled(DarkButton)`
  min-width: fit-content;
  height: fit-content;
  padding: 5px 10px;
`;

export const ErrorContainer = styled.div`
  color: ${themes.colors.KBError};
  padding: 10px;
  margin: 10px 0px;
  border-radius: 15px;
  background-color: ${themes.colors.KBWhite};
`;

export const Textarea = styled(TextareaAutosize)`
  ${({ theme }) => theme.fonts.FoundersGrotesk};
  border: none;
  width: -webkit-fill-available;
  resize: none;
  min-height: 50px;

  &:focus {
    outline: none;
  }
`;

export const Bubble = styled.div`
  ${({ theme }) => theme.fonts.FoundersGrotesk};
  background-color: ${({ theme }) => theme.colors.beigeLight};
  padding: 1em;
  border-radius: 15px;
  width: fit-content;
  white-space: pre-wrap;
  margin: 1.5em auto;
  font-size: smaller;
  display: flex;
  align-items: center;

  a {
    text-decoration: underline;
  }

  svg {
    margin-right: 5px;
  }
`;

export const LockedInput = styled.div`
  ${({ theme }) => theme.fonts.FoundersGrotesk};
  background-color: ${({ theme }) => theme.colors.beigeLight};
  width: 530px;
  white-space: pre-wrap;
  margin: 1.2em auto;
  font-size: 14px;
  display: flex;
  align-items: center;
  padding: 8px;

  img {
    margin: 15px;
  }
`;
export const Icon = styled.img`
  width: 20px;
  height: 20px;
  object-fit: contain;
  margin-right: 15px;
`;

export const RemainingChars = styled.p`
  font-size: 14px;
  ${({ theme }) => theme.fonts.FoundersGrotesk};
  color: ${({ theme }) => theme.colors.night};
`;
